// src/app/core/state/menus/menus.reducer.ts

import { Action, createReducer, on } from '@ngrx/store';
import * as RoommateActions from './roommate.actions';
import { initialState, RoommateState } from './roommate.state';
import { RiskItem } from 'src/app/api/models/quotationRequest.model';

const roommateReducer = createReducer(
  initialState,
  on(
    RoommateActions.patchRoommate,
    (state, action: ReturnType<typeof RoommateActions.patchRoommate>) => ({
      ...state,
      roommate: [
        ...(state.roommate || []),
        ...action.payload.filter((item): item is RiskItem => item !== undefined)
      ]
    })
  ),
  on(RoommateActions.init, state => ({
    ...state,
    ...initialState
  }))
);

export function reducer(state: RoommateState | undefined, action: Action) {
  return roommateReducer(state, action);
}
